export default __webpack_public_path__ + "static/media/garm.cd6deacc.png";